import { useState } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import { Box } from "@material-ui/core";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";

import translate from "i18n/translate";
import { SrAlert, SrDialog, SrButton, Typography } from "components/common";
import OperatorsForm from "./OperatorsForm";
import { OPERATOR_USERNAME, OPERATOR_EMAIL } from "../../../../constants/api";

const EditOperators = ({ onReturn, onUpdate, onDelete, user }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [deleteError, setDeleteError] = useState();
  const intl = useIntl();

  const initialValues = {
    name: user.name,
    email: user.email,
    password: "",
    confirmPassword: "",
  };

  const onSubmit = async (values) => {
    setError();

    const { email, name, password } = values;

    try {
      await axios.put(OPERATOR_USERNAME.replace("{username}", user.username), {
        email,
        name,
        password: password || undefined,
      });

      toast.success(intl.formatMessage({ id: "operators.edited" }));

      onUpdate?.({ ...user, name });
      onReturn?.();
    } catch (error) {
      setError(
        error.response?.data?.error?.message ||
          intl.formatMessage({ id: "errors.somethingWrong" })
      );
    }
  };

  const onDeleteHandler = async () => {
    setDeleteError();

    try {
      setLoading(true);

      await axios.delete(OPERATOR_EMAIL.replace("{email}", user?.email));

      toast.success(intl.formatMessage({ id: "operators.userDeleted" }));

      setOpen(false);

      onDelete?.(user);
      onReturn?.();
    } catch (error) {
      setDeleteError(
        error.response?.data?.error?.message ||
          intl.formatMessage({ id: "errors.somethingWrong" })
      );
    }
    setLoading(false);
  };

  const onDeleteClick = () => {
    setOpen();
  };

  return (
    <>
      <SrDialog
        open={open}
        handleClose={() => {
          setOpen(false);
          setDeleteError();
        }}
        heading={translate("common.delete")}
        actions={
          <>
            <SrButton
              variant="contained"
              color="primary"
              onClick={onDeleteHandler}
              disabled={loading}
            >
              {translate("common.delete")}
            </SrButton>
          </>
        }
      >
        <Typography align="left">
          {translate("operators.confirmDeleteUser", {
            operador: user?.name,
          })}
        </Typography>
        {deleteError && (
          <Box marginTop={2}>
            <SrAlert severity="error">{deleteError}</SrAlert>
          </Box>
        )}
      </SrDialog>
      <OperatorsForm
        onSubmit={onSubmit}
        onReturn={onReturn}
        initialValues={initialValues}
        edit
        onDelete={onDeleteClick}
        error={error}
      />
    </>
  );
};

EditOperators.propTypes = {
  onReturn: PropTypes.func,
  onUpdate: PropTypes.func,
  onDelete: PropTypes.func,
  user: PropTypes.shape({
    name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
  }).isRequired,
};

EditOperators.defaultProps = {
  onReturn: undefined,
  onUpdate: undefined,
  onDelete: undefined,
};

export default EditOperators;
